import styled from 'styled-components'

export const TableContainer = styled.div<{ background?: string }>`
  align-items: center;
  padding: 10px 0 32px;
  background: linear-gradient(180deg, rgba(233, 238, 246, 0.4) 0%, rgba(255, 255, 255, 0) 100%),
    ${(props) => props.background || 'transparent'};
  overflow-x: auto;
  max-width: 100%;
  border-radius: 24px;
`

export const TableToolbar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 16px;
  margin: 5px 0 18px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`

export const TableToolbarLabel = styled.div`
  color: #163247;
  font-family: 'Inter', sans-serif;
  font-size: clamp(1.1rem, 2vw, 1.35rem);
  font-weight: 700;
  line-height: 1.25;
`

export const TableToolbarSearch = styled.div`
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: stretch;
  }
`

export const TableMeta = styled.div`
  margin: 0 0 12px;
  color: #5e7183;
  font-family: 'Public Sans', sans-serif;
  font-size: 0.92rem;
  font-weight: 600;
`

export const TableSurface = styled.div`
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  border: 1px solid #d7e0ea;
  border-radius: 24px;
  box-shadow: 0 18px 40px rgba(23, 55, 77, 0.08);
  overflow: hidden;
`

export const PaginationDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin: 1.5rem 0 0;

  .MuiPagination-ul {
    gap: 4px;
  }

  .MuiPaginationItem-root {
    border-radius: 12px;
    color: #2d749c;
    font-weight: 700;
  }

  .MuiPaginationItem-root.Mui-selected {
    background: #2d749c;
    color: white;
  }
`
export const Table = styled.table`
  width: 100%;
  text-align: left;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: auto;
`
export const TableRow = styled.tr`
  position: relative;
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

  &:nth-child(even) {
    background-color: rgba(233, 238, 246, 0.35);
  }

  &:hover {
    background-color: rgba(45, 116, 156, 0.06);
    box-shadow: inset 0 0 0 1px rgba(45, 116, 156, 0.08);
  }

  &.selected {
    background: linear-gradient(90deg, rgba(198, 1, 107, 0.1) 0, rgba(198, 1, 107, 0.02) 46px), rgba(198, 1, 107, 0.04);
    box-shadow: inset 4px 0 0 #c6016b;
  }

  &.isEditing {
    background-color: rgba(45, 116, 156, 0.08);
    box-shadow: inset 4px 0 0 #2d749c;
  }
`
export const TableHeaders = styled.thead`
  background: linear-gradient(180deg, #f6fafe 0%, #edf4fa 100%);

  tr {
    border-bottom: 1px solid #d7e0ea;
  }

  th {
    padding: 18px 16px;
    color: #163247;
    font-family: 'Public Sans', sans-serif;
    font-size: 0.76rem;
    font-weight: 700;
    letter-spacing: 0.06em;
    line-height: 1.2;
    text-transform: uppercase;
    border-bottom: 1px solid #d7e0ea;
    white-space: nowrap;
  }
`
export const TableHeader = styled.th`
  cursor: pointer;
  user-select: none;
`

export const TableCell = styled.td`
  text-align: left;
  width: auto;
  min-width: 96px;
  overflow: visible;
  white-space: normal;
  position: relative;
  word-wrap: break-word;
  word-break: break-word;
  padding: 16px;
  color: #30485a;
  font-family: 'Inter', sans-serif;
  font-size: 0.94rem;
  line-height: 1.45;
  border-bottom: 1px solid #e5ecf3;
  vertical-align: middle;
`

export const NumberCell = styled.td`
  width: 60px;
  max-width: 60px;
  min-width: 60px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
  color: #2d749c;
  padding: 16px;
  border-bottom: 1px solid #e5ecf3;
`

export const CheckboxCell = styled.td`
  width: 40px;
  max-width: 40px;
  min-width: 40px;
  text-align: center;
  padding: 16px 10px;
  border-bottom: 1px solid #e5ecf3;
`

export const ActionsCell = styled.td`
  width: clamp(116px, 12vw, 180px);
  min-width: 116px;
  max-width: 180px;
  padding: 12px 16px;
  border-bottom: 1px solid #e5ecf3;
  vertical-align: middle;
  white-space: normal;
  overflow: visible;
  text-align: center;

  @media (max-width: 992px) {
    width: 132px;
    min-width: 132px;
  }
`
export const UpdateLink = styled.a`
  align-items: center;
  justify-content: center;
  color: #2d749c;
  font-weight: bold;
  cursor: pointer;
`

export const TableBody = styled.tbody`
  justify-content: space-between;
  min-height: 400px;
`
export const TextView = styled.span`
  font-family: 'Public Sans', sans-serif;
  color: #c6016b;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  cursor: pointer;
`
export const TextUpdate = styled.span`
  font-family: 'Public Sans', sans-serif;
  justify-content: flex-end;
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  cursor: pointer;
  color: #2d749c;
`

export const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
`
